import { routesMap } from '../model/routesMap';

export function mapRoutePath(path: string, enabled: boolean): string;
export function mapRoutePath(paths: string[], enabled: boolean): string[];
export function mapRoutePath(path: string | string[], enabled: boolean): string | string[] {
	if (!enabled) {
		return path;
	}

	if (Array.isArray(path)) {
		return path.map(mapSingle);
	}

	return mapSingle(path);
}

function mapSingle(path: string): string {
	let result = path;

	routesMap.forEach((to, from) => {
		const escaped = escapeRegExp(from);
		const pattern = new RegExp(`(^|/)${escaped}(?=/|$|[?#])`, 'g');
		result = result.replace(pattern, `$1${to}`);
	});

	return result;
}

function escapeRegExp(value: string): string {
	return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
